export const appArrowUpWhiteIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 8L6 14L7.4 15.4L12 10.8L16.6 15.4L18 14L12 8Z" fill="white"/></svg>`,
    name: 'arrow-up-white'
};